import { CircleCard, CircleCardTitle } from '@noissue-ui-kit/card/CircleCard'
import { IContentfulConfigurableCard } from 'types/contentful/configurableCard.types'
import { mapTextColorToClass } from 'app/_components/ContentfulPage/ConfigurableText/ConfigurableText.utils'

export default function ConfigurableTile({
  cardType,
  cardBackgroundColor,
  cardSize,
  cardLink,
  image,
  imageBackgroundColor,
  title,
  titleColor,
  trackingIdentifier,
}: IContentfulConfigurableCard) {
  return (
    <>
      {cardType === 'circle' && (
        <CircleCard
          cardSize={cardSize}
          cardLink={cardLink}
          backgroundColor={cardBackgroundColor}
          image={image}
          imageBackgroundColor={imageBackgroundColor}
          trackingIdentifier={trackingIdentifier}
        >
          {title && (
            <CircleCardTitle
              className={
                mapTextColorToClass[titleColor] || mapTextColorToClass.acai
              }
            >
              {title}
            </CircleCardTitle>
          )}
        </CircleCard>
      )}
    </>
  )
}
